import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IframeTrackerDirective } from './iframe-tracker-directive.directive';



@NgModule({
  declarations: [IframeTrackerDirective],
  exports: [IframeTrackerDirective],
  imports: [
    CommonModule
  ]
})
export class AppIframeTrackerModule { }
